import { Fragment } from 'react';

import { Separator } from '../../Separator/Separator';

import type { FC, ReactNode } from 'react';

import styles from './ContainerHeader.module.scss';

type Props = {
  children?: ReactNode;
};

const ContainerHeader: FC<Props> = ({ children }) => {
  return (
    <Fragment>
      <div className={styles.header}>{children}</div>
      <Separator />
    </Fragment>
  );
};

export { ContainerHeader };
